import { invalidateCache } from "./apiCache";

/** Invalidate cached recipient/patient API data and notify mounted useApi hooks. */
export function notifyRecipientDataStale(recipientId?: string): void {
    const prefixes = ["/api/recipients", "/api/patients", "/api/invoices", "/api/dashboard"];
    if (recipientId) {
        prefixes.push(`/api/recipients/${recipientId}`);
        prefixes.push(`/api/recipients/${recipientId}/questionnaire`);
    }
    invalidateCache(...prefixes);
    window.dispatchEvent(new CustomEvent("cache-invalidated", { detail: prefixes }));
}
